import type { Locale } from '@/config/build';

export const DEVELOPMENT_URLS = new Map<Locale, string>([
  ['br', 'https://local.l.doctoralia.com.br'],
  ['de', 'https://local.l.jameda.de'],
  ['es', 'https://local.l.doctoralia.es'],
  ['it', 'https://local.l.miodottore.it'],
  ['mx', 'https://local.l.doctoralia.com.mx'],
  ['pl', 'https://local.l.znanylekarz.pl'],
  ['tr', 'https://local.l.doktortakvimi.com'],
]);

export const PRODUCTION_URLS = new Map<Locale, string>([
  ['br', 'https://l.doctoralia.com.br'],
  ['de', 'https://l.jameda.de'],
  ['es', 'https://l.doctoralia.es'],
  ['it', 'https://l.miodottore.it'],
  ['mx', 'https://l.doctoralia.com.mx'],
  ['pl', 'https://l.znanylekarz.pl'],
  ['tr', 'https://l.doktortakvimi.com'],
  ['ar', 'https://l.doctoraliar.com'],
  ['co', 'https://l.doctoralia.co'],
  ['cl', 'https://l.doctoralia.cl'],
  ['pe', 'https://l.doctoralia.pe'],
  ['pt', 'https://l.doctoralia.com.pt'],
  ['cz', 'https://l.znamylekar.cz'],
  ['eu-sandbox', 'https://l.znanylekarz.pl'],
  ['sa-sandbox', 'https://l.doctoralia.com.br'],
  ['na-sandbox', 'https://l.doctoralia.com.mx'],
]);

export const getTestingUrl = (testingName: string) => `https://${testingName}.l.tst.docplanner.com`;
